import {
    SET_IS_MENU_ACTIVE,
    SET_ACTIVE_TRACKING_ASIDE_TAB
} from './mutations'

export default {
    async setMenuAction ({ commit }, payload) {
        commit(SET_IS_MENU_ACTIVE, payload)
    },
    async setActiveTrackingAsideTab({ commit }, payload) {
        commit(SET_ACTIVE_TRACKING_ASIDE_TAB, payload)
    }
}
